import React from 'react';
import {observer, inject} from 'mobx-react';
import {observable, autorun} from 'mobx';
import {preview} from '../../libs/api';

@inject('contentStore')
@observer
class NewsEvents extends React.Component {

  @observable previews = [];
  dispose;

  componentWillMount(){
    this.dispose = autorun(() => {
      let news_events = this.props.contentStore.news_events;
      // console.log(toJS(news_events));
      if(news_events && news_events.length>0){
        let promises = [];

        // eslint-disable-next-line array-callback-return
        news_events.map(item => {
          promises.push(
            preview.fetch(item.title).then(data => {
              if(data.title === '') {
                return(
                  <div style={{borderBottom:'1px lightgray solid'}}>
                    <a href={item.title} target="_blank" rel="noopener noreferrer">{item.title}</a>
                  </div>
                );
              }
              return(
                <div className="news-item">
                  <div className="col-md-12 col-sm-12 inline-it-no-justify" style={{padding:'0px', marginBottom:'5px'}}>
                    {data.image && <img className="col-md-2 col-sm-5" src={data.image} alt="not found" style={{width:"50px", height:"50px", padding:'0px', left:'0px'}}/>}
                    <div className="col-md-8 col-sm-5" style={{marginLeft:'5px', padding:'0px'}}>
                      <a href={item.title} target="_blank" rel="noopener noreferrer">{data.title}</a>
                    </div>
                  </div>
                  <p style={{textAlign:'justify', color:'black'}}>{item.description}</p>
                </div>
              )
            }).catch(err => {
              console.log(err);
              return(
                <div style={{borderBottom:'1px lightgray solid'}}>
                  <a href={item.title} target="_blank" rel="noopener noreferrer">{item.title}</a>
                </div>
              )
            })
          );
        });

        Promise.all(promises).then(res => {
          // console.log(res);
          this.previews = res;
        });
      }
    });
  }

/*return(<p key={index}><a href={`${cmURL}/files/${item.file_name}`} target="_blank" rel="noopener noreferrer">{item.title}</a></p>)*/

  render() {
    return (
      <div>{this.previews.length > 0 &&
      this.previews.map((item, index) => {
        return item;
      })
      }</div>
    );
  }
}

export default NewsEvents;


// WEBPACK FOOTER //
// ./src/components/Home/NewsEvents.js